
import { todayDate } from "../../utility/common/helpers/TodayDate";

import { Status } from "../../utility/common/TransactionComponents/TransactionEntity";
export const Field_array = [{ Actual_Value: [""] }, { Range_Qualified: [""] }];



export const WPQ_Groove_Detail = [
  { Column: "WPQ_Detail_Backing", Type: "S" },

  { Column: "WPQ_FM_Specification", Type: "S" },

  { Column: "WPQ_FM_Classification", Type: "S" },

  { Column: "WPQ_FM_filler_Wire", Type: "S" },

  { Column: "WPQ_FM_F_No", Type: "S" },
  { Column: "WPQ_FM_Arc_transfermode", Type: "S" },
  { Column: "WPQ_FM_Consumable_Insert", Type: "S" },
  { Column: "WPQ_FM_Product_Form", Type: "S" },
  { Column: "WPQ_FM_No_of_LayerDeposit", Type: "S" },
  { Column: "WPQ_FM_Thickness_Limit", Type: "S" },
  { Column: "WPQ_FM_Welding_Position", Type: "S" },

  { Column: "WPQ_FM_Progression", Type: "S" },
  { Column: "WPQ_FM_Current_Polarity", Type: "S" },
  { Column: "WPQ_FM_Backing_Gas", Type: "S" },

  { Column: "WPQ_FM_Direct_VisualControl", Type: "S" },
  { Column: "WPQ_FM_Automatic_jointTracking", Type: "S" },
  { Column: "WPQ_FM_Single_Pass_PerSide", Type: "S" },

  { Column: "WPQ_FM_Automatic_AVC_System", Type: "S" },

  { Column: "WPQ_FM_Weld_Deposit_Thickness", Type: "SA" },
];

export const WPQHeader = (wpstype) => {
  return {
    wld_WPSType: wpstype,
    WPSH_WPQ_Process: "",
    WPQ_WelderId: "",
    WPS_Key: "",
    WPQ_WelderName: "",
    WPQ_Date: todayDate,
    WPQ_RecordNo: "",
    WPQ_Wps_RecordNo: "",
    WPQ_ReviNo: "",
    WPQ_Inspection: "",
    WPQ_DOB: todayDate,
    WPQ_Qualificationcode: "",
    WPQ_Last_UpdatedDate: todayDate,
    WPQ_Last_UpdatedBy: "",
    WPQ_Welded_on_coupon: "",
    WPQ_CompanyName: "Godrej & Boyce Mfg. Co. Ltd",
    WPQ_Division: "",
    WPQ_PlantLocation: "",
    WPQ_specialNote: "",
    //WPQ_Status: "Active",
    wld_createdon: "",

    WPQ_BM_BM_ProductForm: "",
    WPQ_BM_BM_Spec: "",
    WPQ_BM_BM_Pno: "",
    WPQ_BM_BM_Gno: "",
    WPQ_BM_BM_Thk: "",
    WPQ_BM_BM_Dia: "",

    WPQ_BM_WTBM_ProductForm: "",
    WPQ_BM_WTBM_Spec: "",
    WPQ_BM_WTBM_Pno: "",
    WPQ_BM_WTBM_Gno: "",
    WPQ_BM_WTBM_Thk: "",
    WPQ_BM_WTBM_Dia: "",

    WPQ_VAR_TypeofJoint_actualValue: "",
    WPQ_VAR_TypeofJoint_RangeQualified: "",
    WPQ_VAR_BaseM_actualValue: "",
    WPQ_VAR_BaseM_RangeQualified: "",
    WPQ_VAR_Pcategory_actualValue: "",
    WPQ_VAR_Pcategory_RangeQualified: "",

    WPQ_BMT_Plate_thickness_ActualV_Groove: "",
    WPQ_BMT_Plate_thickness_ActualV_Fillet: "",
    WPQ_BMT_Plate_thickness_ActualV_Overlay: "",

    WPQ_BMT_Pipe_thickness_ActualV_Groove: "",
    WPQ_BMT_Pipe_thickness_ActualV_Fillet: "",
    WPQ_BMT_Pipe_thickness_ActualV_Overlay: "",

    WPQ_BMT_Pipe_Diameter_ActualV_Groove: "73.00",
    WPQ_BMT_Pipe_Diameter_ActualV_Fillet: "",
    WPQ_BMT_Pipe_Diameter_ActualV_Overlay: "",

    WPQ_BMT_Plate_thickness_RangeQ_Groove: "",
    WPQ_BMT_Plate_thickness_RangeQ_Fillet: "",
    WPQ_BMT_Plate_thickness_RangeQ_Overlay: "",

    WPQ_BMT_Pipe_thickness_RangeQ_Groove: "",
    WPQ_BMT_Pipe_thickness_RangeQ_Fillet: "",
    WPQ_BMT_Pipe_thickness_RangeQ_Overlay: "",

    WPQ_BMT_Pipe_Diameter_RangeQ_Groove: "73.00",
    WPQ_BMT_Pipe_Diameter_RangeQ_Fillet: "",
    WPQ_BMT_Pipe_Diameter_RangeQ_Overlay: "",

    WPQ_WP_Process_Process: "",
    WPQ_WP_Process_Type: "",
    WPQ_WP_Type_Process: "",
    WPQ_WP_Type_Type: "",

    WPQ_Notes: "",

    WPQ_Certi_test_conductedby: "",
    WPQ_Certi_Mechanical_Tesstby: "",
    WPQ_Certi_RT_Film_Rvaluatedby: "",

    WPSH_Status: Status.StatusTempSaved,
    WPSH_Approval_Status: Status.StatusTempSaved,

    WPQ_DocImage: "",
    WPQ_DocImageOriginal: "",

    WPQ_DocImageUrl: "",

    WPQ_DocImageData: {
      pdfsize: "",
      pdfname: "",
      pdftype: "",
    },

    wpq_QualificationDueIn: "",
    WPQ_Process_Category: "",

    WPSH_PreparedBy_Date: todayDate,
    WPSH_PreparedBy_Name: "",
    WPSH_ApprovedBy_Date: todayDate,
    WPSH_ApprovedBy_Name: "",
    WPSH_ApprovedBy_Remark: "",
    WPSH_PreparedBy_Remark: "",
    WPSH_PreparedBy: sessionStorage.getItem("User"),
    WPSH_UpdatedBy: "",
    WPSH_UpdatedOn: "",
    WPSH_ApprovedBy: sessionStorage.getItem("UserName"),

    wpq_signaturePrepared: "",
    wpq_signatureApproved: "",

    // WQC_ fields removed - generated dynamically for reports

    Process1: "",
    Process2: "",
    Process3: "",




  };
};

export const WPQHeader_Tube = (wpstype) => {

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${day}-${month}-${year}`;
  return {
    wld_WPSType: wpstype,
    WPSH_WPQ_Process: "",
    WPSH_WPQ_Type: "",
    WPQ_WelderId: "",
    WPQ_WelderName: "",
    WPQ_Date: todayDate,
    WPQ_RecordNo: "",
    WPQ_Wps_RecordNo: "",
    WPQ_ReviNo: "",
    WPQ_Inspection: "",
    WPQ_DOB: todayDate,
    WPQ_Qualificationcode: "",
    wld_createdon: formattedDate,
    WPQ_Last_UpdatedDate: todayDate,
    WPQ_Last_UpdatedBy: "",
    WPQ_Welded_on_coupon: "",
    WPQ_CompanyName: "Godrej & Boyce Mfg. Co. Ltd",
    WPQ_Division: "",
    WPQ_PlantLocation: "",
    WPQ_specialNote: "",
    //WPQ_Status: "Active",

    WPQ_BM_BM_ProductForm: "",
    WPQ_BM_BM_Spec: "",
    WPQ_BM_BM_Pno: "",
    WPQ_BM_BM_Gno: "",
    WPQ_BM_BM_Thk: "",
    WPQ_BM_BM_Dia: "",

    WPQ_BM_WTBM_ProductForm: "",
    WPQ_BM_WTBM_Spec: "",
    WPQ_BM_WTBM_Pno: "",
    WPQ_BM_WTBM_Gno: "",
    WPQ_BM_WTBM_Thk: "",
    WPQ_BM_WTBM_Dia: "",

    WPQ_VAR_TypeofJoint_actualValue: "",
    WPQ_VAR_TypeofJoint_RangeQualified: "",
    WPQ_VAR_BaseM_actualValue: "",
    WPQ_VAR_BaseM_RangeQualified: "",

    WPQ_FM_PreFillerMetal: "",
    WPQ_FM_WithFillerMetal: "",
    WPQ_FM_FillerProduct: "",
    WPQ_FM_Inserts: "",
    WPQ_FM_FillerOthers: "",

    WPQ_WP_Process_Process: "",
    WPQ_WP_Process_Type: "",
    WPQ_WP_Type_Process: "",
    WPQ_WP_Type_Type: "",

    WPQ_Notes: "",

    WPQ_Certi_test_conductedby: "",
    WPQ_Certi_Mechanical_Tesstby: "",
    WPQ_Certi_RT_Film_Rvaluatedby: "",

    WPQ_BM_RangeQualified_Thk: "",
    WPQ_BM_RangeQualified_Dia: "",

    WPQ_Joint_Type: [{ Actual_Value: ["Tube to Tubesheet"] }, { Range_Qualified: ["Tube to Tubesheet"] }],
    WPQ_Hole_Id: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
    WPQ_Tube_Pitch: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
    WPQ_Groove_Depth: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_Tube_Projection: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
    WPQ_Width_Ligament: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
    WPQ_Pattern: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
    WPQ_Groove_Angle: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
    WPSH_Status: Status.StatusTempSaved,
    WPSH_Approval_Status: Status.StatusTempSaved,


    wld_pdf_image: [
      { Image1: [""] },
      { Image2: [""] },
      { Image3: [""] },
    ],

    WPQ_DocImage: "",
    WPQ_DocImageOriginal: "",

    wpq_QualificationDueIn: "",

    WPQ_DocImageUrl: "",

    WPQ_DocImageData: {
      pdfsize: "",
      pdfname: "",
      pdftype: "",
    },

    Pdf_images: [
      { tube_Hole_ligament: [""] },
      { tube_Hole: [""] },
      { tube_Weld_Joint: [""] },
    ],

    wpq_signaturePrepared: "",
    wpq_signatureApproved: "",

    WPSH_PreparedBy_Date: todayDate,
    WPSH_PreparedBy_Name: "",
    WPSH_ApprovedBy_Date: todayDate,
    WPSH_ApprovedBy_Name: "",
    WPSH_ApprovedBy_Remark: "",
    WPSH_PreparedBy_Remark: "",
    WPSH_PreparedBy: sessionStorage.getItem("User"),
    WPSH_UpdatedBy: "",
    WPSH_UpdatedOn: "",
    WPSH_ApprovedBy: sessionStorage.getItem("UserName"),
  };
};


export const WPQ_Tube_Page2 = {
  WPQD_WP_WeldingProcess: "",
  WPQD_WP_Type: "",
  WPQD_WP_MinimumPreheatTemp: "",
  WPQD_WP_MaximumInterpassTemp: "",
  WPQD_WP_PostHeating: "",
  WPQD_WP_TungstenType: "",
  WPQD_WP_WeldPosition: "",
  WPQD_WP_WeldProgression: "",
  WPQD_WP_NoofPasses: "",

  WPQD_WP_ShieldingGasType: "",
  WPQD_WP_ShieldingFlowRate: "",

  WPQD_WP_BackingGasType: "",
  WPQD_WP_BackingFlowRate: "",
  WPQD_WP_Automatic_Arc_Voltage: "",
  WPQD_WP_Auxiliarygas: "",

  WPQ_OTV_Oscillation: "",
  WPQ_OTV_Expansion: "",
  WPQ_OTV_MethodofCleaning: "",
  WPQ_OTV_OrifceCupSize: "",

  WPQ_Post_WHT_Temp: "",
  WPQ_Post_WHT_Time: "",
  WPQ_Post_WHT_Type: "",
  WPQ_Post_WHT_Heating_Rate: "",
  WPQ_Post_WHT_Cooling_Rate: "",

  WPQ_Page2_Notes: "",

  WPQ_Certification_Welder_Name: "",
  WPQ_Certification_ID: "",
  WPQ_Certification_ConductedBy: "",
  WPQ_Certification_Mechanical_TestsBy: "",
  WPQ_Certification_Lab_RefNo: "",
};

export const WPQ_tubesheet_page2 = [
  { Column: "WPQD_WP_LayerNo", Type: "S" },
  { Column: "WPQD_WP_Filler_Metal_Size", Type: "S" },
  { Column: "WPQD_WP_Amperes", Type: "S" },
  { Column: "WPQD_WP_DC_Pulsing_current", Type: "S" },
  { Column: "WPQD_WP_DC_Pulsing_current_Others", Type: "S" },
  { Column: "WPQD_WP_Volatage_Volts", Type: "S" },
  { Column: "WPQD_WP_Travel_Speed", Type: "S" },
  { Column: "WPQD_WP_Heat_Input", Type: "S" },
  { Column: "WPQD_WP_PolarityOrCurrent", Type: "S" },
];

export const WPQPage1 = {
  WPQ_WelderId: "",
  WPQ_WelderName: "",
  WPQ_Date: "",
  WPQ_RecordNo: "",
  WPQ_Wps_RecordNo: "",
  WPQ_ReviNo: "",
  WPQ_Inspection: "",
  WPQ_DOB: "",
  WPQ_Qualificationcode: "",
  WPQ_Last_UpdatedDate: "",

  WPQ_PlantLocation: "",
  WPQ_specialNote: "",

  WPQ_BM_BM_ProductForm: "",
  WPQ_BM_BM_Spec: "",
  WPQ_BM_BM_Pno: "",
  WPQ_BM_BM_Gno: "",

  WPQ_BM_BM_Thk: "",
  WPQ_BM_BM_Dia: "",

  WPQ_BM_WTBM_ProductForm: "",
  WPQ_BM_WTBM_Spec: "",
  WPQ_BM_WTBM_Pno: "",
  WPQ_BM_WTBM_Gno: "",

  WPQ_BM_WTBM_Thk: "",
  WPQ_BM_WTBM_Dia: "",

  WPQ_VAR_TypeofJoint_actualValue: "",
  WPQ_VAR_TypeofJoint_RangeQualified: "",
  WPQ_VAR_BaseM_actualValue: "",
  WPQ_VAR_BaseM_RangeQualified: "",
  WPQ_VAR_Pcategory_RangeQualified: "",

  WPQ_BMT_Plate_thickness_ActualV_Groove: "",
  WPQ_BMT_Plate_thickness_ActualV_Fillet: "",
  WPQ_BMT_Plate_thickness_ActualV_Overlay: "",

  WPQ_BMT_Pipe_thickness_ActualV_Groove: "",
  WPQ_BMT_Pipe_thickness_ActualV_Fillet: "",
  WPQ_BMT_Pipe_thickness_ActualV_Overlay: "",

  WPQ_BMT_Pipe_Diameter_ActualV_Groove: "",
  WPQ_BMT_Pipe_Diameter_ActualV_Fillet: "",
  WPQ_BMT_Pipe_Diameter_ActualV_Overlay: "",

  WPQ_BMT_Plate_thickness_RangeQ_Groove: "",
  WPQ_BMT_Plate_thickness_RangeQ_Fillet: "",
  WPQ_BMT_Plate_thickness_RangeQ_Overlay: "",

  WPQ_BMT_Pipe_thickness_RangeQ_Groove: "",
  WPQ_BMT_Pipe_thickness_RangeQ_Fillet: "",
  WPQ_BMT_Pipe_thickness_RangeQ_Overlay: "",

  WPQ_BMT_Pipe_Diameter_RangeQ_Groove: "",
  WPQ_BMT_Pipe_Diameter_RangeQ_Fillet: "",
  WPQ_BMT_Pipe_Diameter_RangeQ_Overlay: "",
};

export const WPQ_tubePage1 = {
  WPQ_WelderId: "",
  WPQ_WelderName: "",
  WPQ_DOB: "",
  WPQ_Date: "",
  WPQ_RecordNo: "",
  WPQ_Wps_RecordNo: "",
  WPQ_Qualificationcode: "",

  WPQ_PlantLocation: "",
  WPQ_specialNote: "",

  WPQ_BM_BM_ProductForm: "",
  WPQ_BM_BM_Spec: "",
  WPQ_BM_BM_Pno: "",
  WPQ_BM_BM_Gno: "",
  WPQ_BM_BM_Thk: "",
  WPQ_BM_BM_Dia: "",

  WPQ_BM_WTBM_ProductForm: "",
  WPQ_BM_WTBM_Spec: "",
  WPQ_BM_WTBM_Pno: "",
  WPQ_BM_WTBM_Gno: "",
  WPQ_BM_WTBM_Thk: "",
  WPQ_BM_WTBM_Dia: "",
  WPQ_ReviNo: "",

  WPQ_BM_RangeQualified_Thk: {},
  WPQ_BM_RangeQualified_Dia: {},

  WPQ_Joint_Type: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
  WPQ_Hole_Id: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
  WPQ_Tube_Pitch: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
  WPQ_Groove_Depth: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

  WPQ_Tube_Projection: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
  WPQ_Width_Ligament: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
  WPQ_Pattern: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
  WPQ_Groove_Angle: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

};

export const WPQ_tubePage3 = {
  WPQ_VEX_Report: "",
  WPQ_LPEX_Report: "",
  WPQ_LPEX_Notes: "",
  WPQ_VEX_Notes: "",
  WPQ_MEX_Result: "",
};

export const WPQ_tubePage4 = {
  WPQ_MLP_Result: "",
  WPQ_OT_Notes: "",
  WPQ_Radio_Notes: "",
};


export const errorTubepage3 = {
  WPQ_VEX_WeldPass: {},
  WPQ_VEX_Acceptance_Criteria: {},
  WPQ_VEX_Observation: {},
  WPQ_VEX_Results: {},

  WPQ_LPEX_WeldPass: {},
  WPQ_LPEX_Acceptance_Criteria: {},
  WPQ_LPEX_Observation: {},
  WPQ_LPEX_Results: {},

  WPQ_MEX_Tube_No: {},
  WPQ_MEX_LocA: {},
  WPQ_MEX_LocB: {},
  WPQ_MEX_LocC: {},
  WPQ_MEX_LocD: {},

  WPQ_MEX_Tube_No1: {},
  WPQ_MEX_LocA1: {},
  WPQ_MEX_LocB1: {},
  WPQ_MEX_LocC1: {},
  WPQ_MEX_LocD1: {},

  WPQ_MEX_Tube_No2: {},
  WPQ_MEX_LocA2: {},
  WPQ_MEX_LocB2: {},
  WPQ_MEX_LocC2: {},
  WPQ_MEX_LocD2: {},

  WPQ_MEX_Tube_No3: {},
  WPQ_MEX_LocA3: {},
  WPQ_MEX_LocB3: {},
  WPQ_MEX_LocC3: {},
  WPQ_MEX_LocD3: {},

  WPQ_MEX_Magnification: {},
  WPQ_MEX_Acceptance_Criteria: {},
  WPQ_MEX_Observation: {},

};



export const errorTubepage4 = {



  WPQ_Radio_TubeNo: {},
  WPQ_Radio_Acceptance_Criteria: {},
  WPQ_Radio_Observation: {},
  WPQ_Radio_Results: {},

  WPQ_OT_TypeofTest: {},
  WPQ_OT_Acceptance_Criteria: {},
  WPQ_OT_Observation: {},
  WPQ_OT_Results: {},


  WPQ_MLP_Tube_No: {},
  WPQ_MLP_LocA: {},
  WPQ_MLP_LocB: {},
  WPQ_MLP_LocC: {},
  WPQ_MLP_LocD: {},

  WPQ_MLP_Tube_No1: {},
  WPQ_MLP_LocA1: {},
  WPQ_MLP_LocB1: {},
  WPQ_MLP_LocC1: {},
  WPQ_MLP_LocD1: {},

  WPQ_MLP_Tube_No2: {},
  WPQ_MLP_LocA2: {},
  WPQ_MLP_LocB2: {},
  WPQ_MLP_LocC2: {},
  WPQ_MLP_LocD2: {},

  WPQ_MLP_Tube_No3: {},
  WPQ_MLP_LocA3: {},
  WPQ_MLP_LocB3: {},
  WPQ_MLP_LocC3: {},
  WPQ_MLP_LocD3: {},


  WPQ_MLP_Magnification: {},
  WPQ_MLP_Acceptance_Criteria: {},
  WPQ_MLP_Observation: {},

  WPSH_PWHeatTre_Temperature: {},

  WPSH_PreparedBy_Name: {},
  WPSH_PreparedBy_Date: {},
  WPSH_PreparedBy_Remark: {},

  WPSH_ApprovedBy_Name: {},
  WPSH_ApprovedBy_Date: {},
  WPSH_Approval_Status: {},
  WPSH_ApprovedBy_Remark: {},


};


export const WPQ_tubePage4_Header = {
  WPSH_PreparedBy_Remark: "",
};

export const WPQPage1Date = {
  WPQ_Date: "",
  WPQ_DOB: "",
  WPQ_Last_UpdatedDate: "",
};

export const WPQPage3 = {
  WPQ_Notes: "",
  WPQ_Certi_test_conductedby: "",
  WPQ_Certi_Mechanical_Tesstby: "",
  WPQ_Certi_RT_Film_Rvaluatedby: "",
  WPSH_PreparedBy_Name: "",
  WPSH_ApprovedBy_Name: "",
  WPSH_PreparedBy_Remark: "",
  WPSH_ApprovedBy_Remark: "",
};


export const WPQ_Tube_Page1_Process = [
 

  { Column: "WPSD_FM_SFA", Type: "S" },
  
]







export const checkboxComponent = (valueIndex, Value, booleanIndex) => {

  if (valueIndex === 0 && booleanIndex === "false") {
    Value = "F";
  } else if (valueIndex === 0 && booleanIndex === "true") {
    Value = "";
  }

  if (valueIndex === 1 && booleanIndex === "false") {
    Value = "H";
  } else if (valueIndex === 1 && booleanIndex === "true") {
    Value = "";
  }

  if (valueIndex === 2 && booleanIndex === "false") {
    Value = "V";
  } else if (valueIndex === 2 && booleanIndex === "true") {
    Value = "";
  }

  if (valueIndex === 3 && booleanIndex === "false") {
    Value = "O";
  } else if (valueIndex === 3 && booleanIndex === "true") {
    Value = "";
  }

  if (valueIndex === 4 && booleanIndex === "false") {
    Value = "SP";
  } else if (valueIndex === 4 && booleanIndex === "true") {
    Value = "";
  }

  if (valueIndex === 5 && booleanIndex === "false") {
    Value = "6G";
  } else if (valueIndex === 5 && booleanIndex === "true") {
    Value = "";
  }

  if (valueIndex === 6 && booleanIndex === "false") {
    Value = "5G";
  } else if (valueIndex === 6 && booleanIndex === "true") {
    Value = "";
  }

  return { Value, booleanIndex };
};

export const detailprocess = (resultdata) => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${day}-${month}-${year}`;

  return {
    SK: "",
    PK: "",
    WPQ_WelderId: "",
    WPQ_RecordNo: "",
    WPQ_WelderName: "",
    wld_createdon: formattedDate,
    WPQ_Process: "",
    ProcessElement: "",
    ProcessElementNew: "",

    WPQ_Process_Category: "",
    wld_process_status : "Active",

    WPQ_Type: "",
    WPSH_Status: "",
    WPQ_Welder_ExpiresOn:"",
    WPQ_BM_WTBM_Pno: "",
    WPQ_BMT_Plate_thickness_RangeQ_Overlay: "",
    WPQ_BMT_Pipe_Diameter_RangeQ_Overlay: "",

    WPSD_WP_FillerMetalSIze: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPSD_WP_LayerNumber: Field_array,

    WPSD_FM_SFA: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_Detail_Type: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_Detail_Backing: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Specification: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Classification: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_filler_Wire: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_F_No: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
      { Other: [""] },
    ],

    WPQ_FM_Arc_transfermode: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Consumable_Insert: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Product_Form: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_No_of_LayerDeposit: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Thickness_Limit: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Welding_Position: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Progression: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Current_Polarity: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Backing_Gas: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Direct_VisualControl: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Automatic_jointTracking: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Single_Pass_PerSide: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Automatic_AVC_System: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Weld_Deposit_Thickness: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          { Range_Qualified1: [[""]] },
          { Range_Qualified3: [["OR"]] },
          { Range_Qualified2: [["", "true", "Checked", "No Limit"]] },
        ],
      },
    ],

    WPQ_Groove_610: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Groove_73to610: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Groove_73: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Fillet_610: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Fillet_73to610: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Fillet_73: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Overlay_610: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Overlay_73to610: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],

    WPQ_Overlay_73: [
      { Actual_Value: [""] },
      {
        Range_Qualified: [
          ["", "false", "Unchecked", "F"],
          ["", "false", "Unchecked", "H"],
          ["", "false", "Unchecked", "V"],
          ["", "false", "Unchecked", "O"],
          ["", "false", "Unchecked", "SP"],
          ["", "false", "Unchecked", "6G"],
          ["", "false", "Unchecked", "5G"],
        ],
      },
    ],
    status: "Active",
  };
};

export const errorprocess = () => {
  return {


    WPSD_FM_SFA: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_Detail_Type: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_Detail_Backing: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Specification: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Classification: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_filler_Wire: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_F_No: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
      { Other: [""] },
    ],

    WPQ_FM_Arc_transfermode: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Consumable_Insert: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Product_Form: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_No_of_LayerDeposit: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Thickness_Limit: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Welding_Position: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Progression: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Current_Polarity: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Backing_Gas: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

    WPQ_FM_Direct_VisualControl: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Automatic_jointTracking: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Single_Pass_PerSide: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],

    WPQ_FM_Automatic_AVC_System: [
      { Actual_Value: [""] },
      { Range_Qualified: [""] },
    ],


    WPQ_FM_Weld_Deposit_Thickness: [
      { Actual_Value: [""] },
      { Range_Qualified: [{ Range_Qualified1: [[""]] }] },
    ],
  };
};